@if (loggedIn) {
  <!-- Toolbar -->
  <mat-toolbar class="zd-toolbar">
    <a class="toolbar-brand" routerLink="/dashboard" title="Return to dashboard">
      <img src="./assets/logo_transparent.png" alt="Zeidman Development" class="toolbar-logo" />
      <span class="toolbar-title">Audit Trail</span>
    </a>
    <span class="toolbar-spacer"></span>
    <span class="user-info">{{ fullName }}</span>
    <span class="org-info">{{ orgName }}</span>
    <button mat-icon-button (click)="logOut()" aria-label="Sign out" class="logout-btn"
      matTooltip="Sign out" matTooltipPosition="below">
      <mat-icon>logout</mat-icon>
    </button>
  </mat-toolbar>

  <!-- Sidebar + Content -->
  <div class="main-layout">
    <nav class="sidebar">
      <div class="sidebar-inner">
        <ul class="sidebar-nav">
          <li class="sidebar-item">
            <a class="sidebar-link" routerLink="/dashboard" routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }">
              <mat-icon matTooltip="Dashboard" matTooltipPosition="right">dashboard</mat-icon>
            </a>
          </li>
          <hr class="sidebar-divider">
          <!-- In-app settings: unified page (Authentication / Security / Tile Security / User Movement Setup).
               Icon options: settings (default) | tune | manage_accounts -->
          <li class="sidebar-item">
            <a class="sidebar-link" routerLink="/configuration" routerLinkActive="active-link">
              <mat-icon matTooltip="Settings" matTooltipPosition="right">settings</mat-icon>
            </a>
          </li>
          <!-- External Audit Trail configuration & installation app (Config Web).
               Icon options: build (default) | construction | cloud_sync | open_in_new -->
          <li class="sidebar-item">
            <a class="sidebar-link" (click)="openConfigTool()" style="cursor: pointer;">
              <mat-icon matTooltip="Audit Trail Configuration" matTooltipPosition="right">build</mat-icon>
            </a>
          </li>
          @if (exportsAvailable) {
            <li class="sidebar-item">
              <a class="sidebar-link" routerLink="/exports" routerLinkActive="active-link">
                <mat-icon matTooltip="Point-in-Time Exports" matTooltipPosition="right">history</mat-icon>
              </a>
            </li>
          }
          @if (insightsAvailable) {
            <hr class="sidebar-divider">
            <li class="sidebar-item">
              <a class="sidebar-link" routerLink="/insights" routerLinkActive="active-link">
                <mat-icon matTooltip="User Movement Insights" matTooltipPosition="right">insights</mat-icon>
              </a>
            </li>
          }
          <hr class="sidebar-divider">
          <li class="sidebar-item sidebar-item-bottom">
            <a class="sidebar-link" href="https://www.zeidman.info" target="_blank">
              <img src="./assets/logo_transparent.png" width="28" height="28"
                alt="&copy; Zeidman Development {{ currentYear }}"
                matTooltip="&copy; Zeidman Development {{ currentYear }}" matTooltipPosition="right">
            </a>
          </li>
        </ul>
      </div>
    </nav>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
